import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";

function BlogsTab() {
  const [showForm, ] = useState(false);
  const [title, setTitle] = useState("");
  const [titleError, setTitleError] = useState(false);

  const hendleBlur = () => {
    if (title.trim() === "") {
      setTitleError(true);
    } else {
      setTitleError(false);
    }
  };

  return (
    <div>
      <div className="">
        <div className="card-body">
          <Row>
            <Col md={12}>
              <div className="d-flex justify-content-between flex-wrap align-items-center mb-3">
                <h6 className="fs-6 fw-bold mb-0">
                  {showForm ? "Create New Blog" : "0 Blogs shared by me"}
                </h6>
                {/* {!showForm && (
                  <Link
                    className="parkrevieBtn text-center mt-sm-0 mt-2"
                    to="/profile/blog/create"
                    onClick={handleCreateClick}
                  >
                    Create Blog
                  </Link>
                )} */}
              </div>
            </Col>
            {showForm ? (
              <Col md={12}>
                <div className="card card_bodyPadding">
                  <div className="card-body p-4">
                    <form action="">
                      <input type="hidden" />
                      <Row>
                        <Col md={12}>
                          <div className="mb-3 field-blogform-title required">
                            <label className="Modal_label" for="blogform-title">
                              Title <span className="necessary">*</span>
                            </label>
                            <input
                              type="text"
                              className={`form-control ${
                                titleError ? "is-invalid" : ""
                              }`}
                              placeholder="Enter Blog Title"
                              value={title}
                              onChange={(e) => setTitle(e.target.value)}
                              onBlur={hendleBlur}
                            />
                            {titleError && (
                              <div className="invalid-feedback">
                                Title cannot be blank.
                              </div>
                            )}
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6}>
                          <div className="mb-3 field-blogform-blog_tags required">
                            <label
                              className="Modal_label"
                              for="blogform-blog_tags"
                            >
                              Blog Tag <span className="necessary">*</span>
                            </label>
                            <br />
                            pending!
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="mb-3 field-blogform-blog_tags required">
                            <label
                              className="Modal_label"
                              for="blogform-blog_tags"
                            >
                              Blog Topics <span className="necessary">*</span>
                            </label>
                            <br />
                            pending!
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={6}>
                          <div className="mb-3 field-blogform-banner_image">
                            <label
                              className="Modal_label"
                              for="blogform-banner_image"
                            >
                              Blog Image (JPEG / JPG / PNG / 940px * 430px /
                              250kb)
                            </label>
                            <input
                              type="hidden"
                              name="BlogForm[banner_image]"
                              value=""
                            />
                            <input
                              type="file"
                              id="blogform-banner_image"
                              className="form-control"
                              name="BlogForm[banner_image]"
                            />

                            <div className="invalid-feedback"></div>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <div className="mb-3 field-blogform-description required">
                          <label
                            className="Modal_label"
                            for="blogform-description"
                          >
                            Description <span className="necessary">*</span>
                          </label>
                          <textarea
                            id="blogform-description"
                            className="form-control"
                            name="BlogForm[description]"
                            rows="6"
                            placeholder="Description Detail "
                            aria-required="true"
                            style={{ display: "none" }}
                          ></textarea>
                           editor pending!
                        </div>
                       
                      </Row>
                      <Row>
                        <Col md={3}>
                          <div className="mb-3 field-blogform-status">
                            <label className="Modal_label">
                              Blog Status <span className="necessary">*</span>
                            </label>
                            <input
                              type="hidden"
                              name="BlogForm[status]"
                              value=""
                            />
                            <div
                              id="blogform-status"
                              prompt="--Select --"
                              role="radiogroup"
                            >
                              <div className="form-check">
                                <input
                                  type="radio"
                                  id="i0"
                                  className="form-check-input"
                                  name="BlogForm[status]"
                                  value="1"
                                />
                                <label className="form-check-label" for="i0">
                                  Published
                                </label>
                              </div>

                              <div className="form-check">
                                <input
                                  type="radio"
                                  id="i1"
                                  className="form-check-input"
                                  name="BlogForm[status]"
                                  value="0"
                                />
                                <label className="form-check-label" for="i1">
                                  UnPublished
                                </label>
                                <div className="invalid-feedback"></div>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12} className="pb-3">
                          <div className="creat-safri float-end w-auto">
                            <button
                              type="submit"
                              className="safari_create font_set px-5"
                            >
                              Save
                            </button>{" "}
                          </div>
                        </Col>
                      </Row>
                    </form>
                  </div>
                </div>
              </Col>
            ) : (
              <p className="px-3 mb-0">No Blog Found!</p>
            )}
          </Row>
        </div>
      </div>
    </div>
  );
}

export default BlogsTab;
